import axios from "axios"
import { useEffect, useState } from "react"
import FormButton from "../../components/FormButton"
import { getToken } from "../../user/User"
import Select from "react-select"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { getStatusOptions } from "../../data/Data"

const ClientDetailView = ({ id,
    companyName, setCompanyName,
    sector, setSector,
    salesPerson, setSalesPerson,
    status, setStatus,
    statusUpdated, setStatusUpdated,
    initialPrice, setInitialPrice,
    monthlyPrice, setMonthlyPrice,
    initialPaymentDate, setInitialPaymentDate,
    serviceAgreementStart, setServiceAgreementStart,
    serviceAgreementEnd, setServiceAgreementEnd,
    builtWebsite, setBuiltWebsite,
    tags, setTags,
    contactPersonName, setContactPersonName,
    emailAddress, setEmailAddress,
    phoneNumber, setPhoneNumber,
    notes, setNotes,
    tasks, setTasks,
}) => {
    const navigate = useNavigate()
    
    const [salesPersonSelect, setSalesPersonSelect] = useState(<></>)
    const [tagsSelect, setTagsSelect] = useState(<></>)
    const [sectorSelect, setSectorSelect] = useState(<></>)
    const [prioOptions, setPrioOptions] = useState([
            {
                value: "Low",
                label: "Low"
            },
            {
                value: "Medium",
                label: "Medium"
            },
            {
                value: "High",
                label: "High"
            }
        ])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/users", { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            const options = []
            if(res.data != null) {
                res.data.forEach((user, _) => {
                    options.push({
                        value: user.id,
                        label: user.name
                    })
                })
            }
            setSalesPersonSelect(<Select options={options} onChange={(choice) => setSalesPerson(choice.value)} value={options.filter(option => option.value == salesPerson)} />)
        }).catch(error => {
            console.error(error)
            toast.error("Unable to load sales persons")
        })
        
        axios.get(process.env.REACT_APP_API_URL + "/api/tags", { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            const options = []
            if(res.data != null) {
                res.data.forEach((tag, _) => {
                    options.push({
                        value: tag.id,
                        label: tag.name
                    })
                })
            }
            setTagsSelect(<Select
                isMulti
                options={options}
                closeMenuOnSelect={false}
                onChange={(choice) => setTags(choice.map(tag => tag.value))} value={options.filter(option => tags != null && tags.includes(option.value))} />)
        }).catch(error => {
            console.error(error)
            toast.error("Unable to load tags")
        })
        
        axios.get(process.env.REACT_APP_API_URL + "/api/sectors", { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            const options = []
            if(res.data != null) {
                res.data.forEach((sector, _) => {
                    options.push({
                        value: sector.id,
                        label: sector.name
                    })
                })
            }
            setSectorSelect(<Select options={options} onChange={(choice) => setSector(choice.value)} value={options.filter(option => option.value == sector)} />)
        }).catch(error => {
            console.error(error)
            toast.error("Unable to load sectors")
        })
    }, [salesPerson, tags, sector])

    const handleBack = async e => {
        e.preventDefault()
        navigate("/client")
    }

    const onSave = async e => {
        e.preventDefault()

        if(!validate()) {
            return
        }

        save()
    }

    function save(newStatus, newTasks) {
        axios.put(process.env.REACT_APP_API_URL + "/api/clients/" + id, JSON.stringify({
            "company_name": companyName,
            "sector": sector,
            "sales_person": salesPerson,
            "status": newStatus == null ? status : newStatus,
            "initial_price": parseInt(initialPrice),
            "monthly_price": parseInt(monthlyPrice),
            "initial_payment_date": new Date(initialPaymentDate),
            "service_agreement_start": new Date(serviceAgreementStart),
            "service_agreement_end": new Date(serviceAgreementEnd),
            "built_website": builtWebsite,
            "tags": tags,
            "contact_person": contactPersonName,
            "email_address": emailAddress,
            "phone_number": phoneNumber,
            "notes": notes,
            "tasks": newTasks == null ? tasks : newTasks,
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            const data = res.data
            setTasks(data.tasks)
            toast.success("Saved client " + companyName + " (#" + id + ").")
        }).catch(error => {
            if (error.response) {
                let data = error.response.data
                if(data != undefined) {
                    if(data.users != undefined) {
                        toast.error("Unable to find user #" + data.users[0] + ".")
                        return
                    }
                    if(data.sectors != undefined) {
                        toast.error("Unable to find sector #" + data.sectors[0] + ".")
                        return
                    }
                    if(data.tags != undefined) {
                        toast.error("Unable to find tag #" + data.tags[0] + ".")
                        return
                    }
                }
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find client #" + id + ".")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is a client with the same name and email address.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const onDelete = async e => {
        e.preventDefault()
        navigate("/client/delete/" + id)
    }

    const onCreate = async e => {
        e.preventDefault()
        
        if(!validate()) {
            return
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/clients", JSON.stringify({
            "company_name": companyName,
            "sector": sector,
            "sales_person": salesPerson,
            "status": status,
            "initial_price": parseInt(initialPrice),
            "monthly_price": parseInt(monthlyPrice),
            "initial_payment_date": new Date(initialPaymentDate),
            "service_agreement_start": new Date(serviceAgreementStart),
            "service_agreement_end": new Date(serviceAgreementEnd),
            "built_website": builtWebsite,
            "tags": tags,
            "contact_person": contactPersonName,
            "email_address": emailAddress,
            "phone_number": phoneNumber,
            "notes": notes,
            "tasks": tasks,
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            toast.success("Created client " + companyName + " (#" + res.data.id + ").")
            navigate("/client/" + res.data.id)
        }).catch(error => {
            if (error.response) {
                let data = error.response.data
                if(data != undefined) {
                    if(data.users != undefined) {
                        toast.error("Unable to find user #" + data.users[0] + ".")
                        return
                    }
                    if(data.sectors != undefined) {
                        toast.error("Unable to find sector #" + data.sectors[0] + ".")
                        return
                    }
                    if(data.tags != undefined) {
                        toast.error("Unable to find tag #" + data.tags[0] + ".")
                        return
                    }
                }
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is a client with the same name and email address.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    function validate() {
        if(serviceAgreementStart > serviceAgreementEnd) {
            toast.error("Service agreement start date must not be after end date.")
            return false
        }
        return true
    }
    
    const didShowUp = async e => {
        e.preventDefault()
        updateMeeting(true)
    }
    
    const didNotShowUp = async e => {
        e.preventDefault()
        updateMeeting(false)
    }

    async function updateMeeting(showup) {
        axios.post(process.env.REACT_APP_API_URL + "/api/clients/meeting/" + id, JSON.stringify({
            "showup": showup,
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Updated client " + companyName + " (#" + id + ").")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find client #" + id + ".")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    async function updateLastContacted() {
        let updated = new Date()
        setStatusUpdated(updated)
        axios.post(process.env.REACT_APP_API_URL + "/api/clients/contact/" + id, JSON.stringify({
            "updated": Math.floor(updated.getTime() / 1000),
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Updated client " + companyName + " (#" + id + ").")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find client #" + id + ".")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const setInitialPaymentDateString = (value) => {
        setInitialPaymentDate(new Date(value))
    }
    const setServiceAgreementStartString = (value) => {
        setServiceAgreementStart(new Date(value))
    }
    const setServiceAgreementEndString = (value) => {
        setServiceAgreementEnd(new Date(value))
    }

    const checkTask = (taskId, checked) => {
        const missing = tasks.filter(task => !task.checked).length
        console.log("Checked task " + taskId + ": " + checked)
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId ? { ...task, checked } : task
            )
        )

        if(missing === 1 && status != "Done" && status != "Sold") {
            const moveToDone = window.confirm("Do you want to move the client to status 'Done'?");
            if (moveToDone) {
                setStatus("Done")
                const newTasks = tasks.map(task =>
                    task.id === taskId ? { ...task, checked } : task
                )
                save("Done", newTasks)
            }
        }
    }

    const updateTaskName = (taskId, name) => {
        console.log("Update task " + taskId + " name: " + name)
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId ? { ...task, name } : task
            )
        )
    }

    const updateTaskPrio = (taskId, prio) => {
        console.log("Update task " + taskId + " prio: " + prio)
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId ? { ...task, prio } : task
            )
        )
    }

    const updateTaskDueDate = (taskId, due_date) => {
        due_date = new Date(due_date)
        console.log("Update task " + taskId + " due date: " + due_date)
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId ? { ...task, due_date } : task
            )
        )
    }

    const deleteTask = (taskId) => {
        console.log("Deleting task " + taskId)
        setTasks(prevTasks => prevTasks.filter(task => task.id !== taskId))
    }

    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Back to overview</button><br /><br />

            <form className="form-horizontal">
                <div className="card card-primary">
                    <div className="card-body row">
                        <div className="col-12 col-md-9" style={{borderRight: "solid black"}}>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <FormButton label="Company name" id="companyName" required="required" value={companyName} setValue={setCompanyName} icon="fa-solid fa-building" size="col-12" />
                                    <span>Sector</span>
                                    {sectorSelect}
                                    <span>Tags</span>
                                    {tagsSelect}
                                </div>
                                
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span>Salesperson</span>
                                    {salesPersonSelect}
                                    <span>Status</span>
                                    <Select options={getStatusOptions()} onChange={(choice) => setStatus(choice.value)} value={getStatusOptions().filter(option => option.value == status)} />
                                    { statusUpdated && (
                                        <span>since { statusUpdated.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) }</span>
                                    )}
                                    <br />
                                    { id != null && status == "MeetingBooked" && ( 
                                        <>
                                            <button className="btn btn-success col-5" onClick={didShowUp}>Showed up</button>&nbsp;
                                            <button className="btn btn-danger col-6" onClick={didNotShowUp}>Didn't showed up</button>
                                        </>
                                    )}
                                </div>

                                <div className="col-lg-4 col-md-6 col-12">
                                    <FormButton label="Initial payment" id="initialPayment" value={initialPaymentDate.toLocaleDateString('en-CA')} setValue={setInitialPaymentDateString} type="date" icon="fa-solid fa-money-bill" size="col-12" />
                                    <FormButton label="Initial price" id="initialPrice" value={initialPrice} setValue={setInitialPrice} type="number" icon="fa-solid fa-money-bill" size="col-12" />
                                    <FormButton label="Monthly price" id="monthlyPrice" value={monthlyPrice} setValue={setMonthlyPrice} type="number" icon="fa-solid fa-money-bill" size="col-12" />
                                    <div className="icheck-primary">
                                        <input type="checkbox" id="builtWebsite" value="builtWebsite" checked={builtWebsite} onChange={(event) => setBuiltWebsite(event.target.checked)} />
                                        <label htmlFor="builtWebsite" style={{margin: "10px"}}>Built Website</label>
                                    </div>
                                </div>

                                { (status == "Sold" || status == "Done") && (
                                    <div className="col-lg-4 col-md-6 col-12">
                                        <h5>Service agreement</h5>
                                        <FormButton label="Start" id="serviceAgreementStart" value={serviceAgreementStart.toLocaleDateString('en-CA')} setValue={setServiceAgreementStartString} type="date" icon="fa-solid fa-file-contract" size="col-12" />
                                        <FormButton label="End" id="serviceAgreementEnd" value={serviceAgreementEnd.toLocaleDateString('en-CA')} setValue={setServiceAgreementEndString} type="date" icon="fa-solid fa-file-contract" size="col-12" />
                                    </div>
                                )}
                            </div>
                            <br />
                            <div className="row">
                                <h5>Contact Person</h5>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <FormButton label="Name" id="personName" required="required" value={contactPersonName} setValue={setContactPersonName} icon="fa-solid fa-user" size="col-12" />
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <FormButton label="Email address" id="emailAddress" required="required" type="email" value={emailAddress} setValue={setEmailAddress} icon="fa-solid fa-envelope" size="col-12" />
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <FormButton label="Phone number" id="phoneNumber" required="required" type="phone" value={phoneNumber} setValue={setPhoneNumber} icon="fa-solid fa-phone" size="col-12" />
                                </div>
                            </div>
                            { id != null && (emailAddress != "" || phoneNumber != "") && ( 
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-12">
                                        {
                                            //Empty to align further items 
                                        }
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-12">
                                        { emailAddress != "" && ( 
                                            <button className="btn btn-secondary" onClick={(e) => {
                                                e.preventDefault()
                                                window.location.href = "mailto:" + emailAddress
                                                updateLastContacted()
                                            }}>Send mail</button>
                                        )}
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-12">
                                        { phoneNumber != "" && ( 
                                            <>
                                                <button className="btn btn-secondary" onClick={(e) => {
                                                    e.preventDefault()
                                                    window.location.href = "tel:" + phoneNumber
                                                }}>Call client</button>
                                                <button className="btn btn-secondary" onClick={(e) => {
                                                    e.preventDefault()
                                                    updateLastContacted()
                                                }}>Reached client</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            <FormButton label="Notes" id="notes" value={notes} setValue={setNotes} type="textarea" icon="fa-solid fa-notes" size="col-12" />
                        </div>
                        <div className="col-12 col-md-3">
                            <h5>Tasks</h5>
                            {tasks == null ? "" : tasks.map(task => <div key={task.id}>
                                <div className="icheck-primary">
                                    <input type="checkbox" id={task.id} value={task.name} checked={task.checked} onChange={e => checkTask(task.id, e.target.checked)} />
                                    <label style={{width: "100%"}} htmlFor={task.id}>
                                        <input type="text" className="form-control" placeholder="Name" required={true} value={task.name} onChange={e => updateTaskName(task.id, e.target.value)} />
                                    </label>
                                </div>
                                <div className="row">
                                    <Select className="col-6" options={prioOptions} onChange={(choice) => updateTaskPrio(task.id, choice.value)} value={prioOptions.filter(option => option.value == task.prio)} />
                                    <input style={{width: "50%"}} className="form-control" placeholder="Due date" value={new Date(task.due_date).toLocaleDateString('en-CA')} onChange={e => updateTaskDueDate(task.id, e.target.value)} type="date" />
                                </div>
                                <button style={{marginTop: "5px"}} className="btn btn-secondary" onClick={(e) => {
                                    e.preventDefault()
                                    deleteTask(task.id)
                                }}>Delete task</button>
                                <hr />
                            </div>)}
                            <button className="btn btn-success" onClick={(e) => {
                                e.preventDefault()
                                let id = tasks.length > 0 ? Math.max(...tasks.map(task => task.id)) : 0
                                id++
                                const due_date = new Date()
                                due_date.setDate(due_date.getDate() + 30)
                                const task = {
                                    id: id,
                                    name: "",
                                    checked: false,
                                    prio: "Low",
                                    due_date: due_date
                                }
                                setTasks(prevTasks => [...prevTasks, task])
                            }}>Add task</button>
                        </div>
                    </div>

                    <div className="card-footer">
                        {id === null ? (
                            <button className="btn btn-success" onClick={onCreate}>Create client</button>
                        ) : (
                            <>
                                <button className="btn btn-primary" onClick={onSave}>Save client</button>
                                <button className="btn btn-danger" onClick={onDelete}>Delete client</button>
                            </>
                        )}
                    </div>
                </div>
            </form>
        </>
    )
}
   
export default ClientDetailView